var _rect, _rect2, _g, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 1.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7499_204527",
    style: {
      maskType: "#alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7499_204527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20C10.9625 20 9.9875 19.803 9.075 19.409C8.1625 19.0155 7.36875 18.4813 6.69375 17.8063C6.01875 17.1313 5.4845 16.3375 5.091 15.425C4.697 14.5125 4.5 13.5375 4.5 12.5C4.5 11.4625 4.697 10.4875 5.091 9.575C5.4845 8.6625 6.01875 7.86875 6.69375 7.19375C7.36875 6.51875 8.1625 5.98425 9.075 5.59025C9.9875 5.19675 10.9625 5 12 5C13.0375 5 14.0125 5.19675 14.925 5.59025C15.8375 5.98425 16.6313 6.51875 17.3063 7.19375C17.9813 7.86875 18.5155 8.6625 18.909 9.575C19.303 10.4875 19.5 11.4625 19.5 12.5C19.5 13.5375 19.303 14.5125 18.909 15.425C18.5155 16.3375 17.9813 17.1313 17.3063 17.8063C16.6313 18.4813 15.8375 19.0155 14.925 19.409C14.0125 19.803 13.0375 20 12 20ZM11.25 18.4625V17C10.8375 17 10.4845 16.8533 10.191 16.5597C9.897 16.2657 9.75 15.9125 9.75 15.5V14.75L6.15 11.15C6.1125 11.375 6.078 11.6 6.0465 11.825C6.0155 12.05 6 12.275 6 12.5C6 14.0125 6.497 15.3375 7.491 16.475C8.4845 17.6125 9.7375 18.275 11.25 18.4625ZM16.425 16.55C16.675 16.275 16.9 15.978 17.1 15.659C17.3 15.3405 17.4657 15.0092 17.5972 14.6652C17.7282 14.3217 17.8283 13.9688 17.8973 13.6063C17.9658 13.2438 18 12.875 18 12.5C18 11.275 17.6595 10.1562 16.9785 9.14375C16.297 8.13125 15.3875 7.4 14.25 6.95V7.25C14.25 7.6625 14.1033 8.0155 13.8097 8.309C13.5157 8.603 13.1625 8.75 12.75 8.75H11.25V10.25C11.25 10.4625 11.1783 10.6405 11.0347 10.784C10.8908 10.928 10.7125 11 10.5 11H9V12.5H13.5C13.7125 12.5 13.8907 12.5717 14.0347 12.7153C14.1783 12.8592 14.25 13.0375 14.25 13.25V15.5H15C15.325 15.5 15.6187 15.5967 15.8812 15.7902C16.1437 15.9842 16.325 16.2375 16.425 16.55Z",
    fill: "#959595"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 1.5,
    stroke: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicIconImage);
export default __webpack_public_path__ + "static/media/PublicIconImage.0ba5d7b7fd4da4703576dba477f35868.svg";
export { ForwardRef as ReactComponent };